var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"PublicVaild"},[_vm._t("PageBody")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }